import { routesAPI } from "../backend/api/api";
import ApiService from "../lib/services/ApiService";
import { QueuedRow } from "./queue";

/**
 * Replays one queued row against the live API. Always sends the row's stored
 * Idempotency-Key so a request that reached the server before the connection
 * dropped is deduped server-side instead of applied twice.
 *
 * Two transports on purpose: point-visited goes through the axios client in
 * backend/api/api.ts (same as the live saga), while the visit report and the
 * household update go through lib/services/ApiService, which is the transport
 * their SagaWrapper sagas use. Replaying over the wrong one would change headers
 * and auth behaviour relative to the original call.
 */
export const replayRow = async (row: QueuedRow): Promise<unknown> => {
  const headers = { "Idempotency-Key": row.idempotencyKey };
  const payload = row.payload as any;

  switch (row.type) {
    case "MARK_POINT_VISITED":
      return routesAPI.markPointVisited(payload.routeId, payload.pointId, row.idempotencyKey);
    case "UNMARK_POINT_VISITED":
      return routesAPI.unmarkPointVisited(payload.routeId, payload.pointId, row.idempotencyKey);
    case "SUBMIT_VISIT_REPORT":
      return ApiService.call("put", `/api/auth/visits/${payload.id}`, payload.data, {}, headers);
    case "UPDATE_HOUSEHOLD_CONTACT":
      return ApiService.call("put", `/api/auth/households/${payload.id}`, payload.data, {}, headers);
    default: {
      // Exhaustiveness guard: adding a QueuedActionType without a replay arm is a
      // compile error rather than a silently dropped row.
      const never: never = row.type;
      throw new Error(`No replay handler for queued action ${never}`);
    }
  }
};
